import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
} from "react";
import _ from "lodash";
import { useWeb3React } from "@web3-react/core";
import "ol/ol.css";
import ModalBuyPlot from "../modal/ModalBuyPlot.js";
import ModalBuyPlotTxnSuccess from "../modal/ModalBuyPlotTxnSuccess.js";
import ModalBuyCondo from "../modal/ModalBuyCondo";
import {
  CHAIN,
  INVENTORY_TYPE,
  PLOT_BLOCKCHAIN_CATEGORY,
  PLOT_STATUS,
} from "../../utils/constants/config.js";
import ModalInventoryDetail from "../modal/ModalInventoryDetail.js";
import CustomLoader from "../../layout/CustomLoader.js";

import {
  filterPlots,
  plotMataDataChangeListnerHelper,
  SetupMapHelper,
  getPlotsLayer,
  clearSelectedFeature,
  addMapSelect,
} from "./ethMapHelper.js";
import {
  addEithPlotChangeListner,
  getAndReleaseLockedCondo,
  getPreviousLockedPlots,
} from "../../actions/DataActions.js";
import Filters from "../containertool/ContainerTool.js";
import "../../assets/css/style.css";
import { AppContext } from "../walletsManagment/connectors.js";

const EthMap = () => {
  const mapRef = useRef();
  const mapSelector = useRef();
  const plotslayerRef = useRef(null);
  const zoomLevelRef = useRef({ isZoomFiltered: false, zoomLevel: 0 });
  const firestoreListnerRef = useRef(null);
  const { account } = useWeb3React();
  const { eithAuthToken, values } = useContext(AppContext);
  const plotsDataRef = useRef(null);
  const [state, setState] = useState({
    isLoadingData: true,
    showBuyModal: false,
    showBuySuccesModal: false,
    inventoryType: "plots", // condos
    isShowPlotDetail: false,
    plotId: 0,
    plotSize: "all",
    plotStatus: "all",
    showMyPlots: false,
    showCondoPurchase: false,
  });

  const handleCloseBuyModal = (successStatus) => {
    
    clearSelectedFeature(mapSelector.current);
    if (successStatus == true) {
      setState((state) => ({
        ...state,
        showBuyModal: false,
        showBuySuccesModal: true,
      }));
    } else {
      setState((state) => ({
        ...state,
        showBuyModal: false,
      }));
    }
  };

  const handleCloseBuyCondoModal = (successStatus) => {
    clearSelectedFeature(mapSelector.current);
    if (successStatus == true) {
      setState((state) => ({
        ...state,
        showCondoPurchase: false,
        showBuySuccesModal: true,
      }));
    } else {
      setState((state) => ({
        ...state,
        showCondoPurchase: false,
      }));
    }
  };

  const handleCloseSucessModal = () => {
    setState((state) => ({
      ...state,
      showBuySuccesModal: false,
    }));
  };

  const handlePlotSelection = (e) => {
    if (e.selected?.length > 0 && e.selected[0].values_) {
      let inventoryType = e.selected[0]?.values_?.type;

      if (inventoryType == INVENTORY_TYPE.CONDO) {
        setState((state) => ({
          ...state,
          showCondoPurchase: true,
        }));
      } else {
        let plotId = e.selected[0]?.values_?.plot_id;
        let selectedPlot = _.find(
          plotsDataRef.current ?? [],
          (item) => item.plot_id == plotId
        );
        if (
          selectedPlot.status == PLOT_STATUS.AVAILABLE ||
          selectedPlot.status == PLOT_STATUS.LOCKED
        ) {
          setState((state) => {
            return {
              ...state,
              showBuyModal: true,
              inventoryType: "plots",
              plotId: plotId,
              selectedPlot: selectedPlot,
            };
          });
        } else {
          clearSelectedFeature(mapSelector.current);
          setState((state) => ({
            ...state,
            isShowPlotDetail: true,
            inventoryType: "plots",
            plotId: plotId,
            selectedPlot: selectedPlot,
          }));
        }
      }
    }
  };

  const setupZoomListener = () => {
    mapRef.current?.on("moveend", (e) => {
      var newZoom = mapRef.current.getView().getZoom();

      if (zoomLevelRef.current.zoomLevel != newZoom) {
        if (
          newZoom < 8 &&
          state.plotSize == "all" &&
          state.plotStatus == "all"
        ) {
          filterPlots(
            plotslayerRef.current,
            account,
            plotsDataRef.current,
            [
              PLOT_BLOCKCHAIN_CATEGORY.LARGE,
              PLOT_BLOCKCHAIN_CATEGORY.GIGA,
              PLOT_BLOCKCHAIN_CATEGORY.MEDIUM,
            ],
            state.plotStatus,
            state.showMyPlots
          );
          zoomLevelRef.current.isZoomFiltered = true;
        } else if (
          zoomLevelRef.current.isZoomFiltered &&
          state.plotSize == "all" &&
          state.plotStatus == "all"
        ) {
          zoomLevelRef.current.isZoomFiltered = false;
          // filterPlots(
          //   plotslayerRef.current,
          //   account,
          //   plotsDataRef.current,
          //   [state.plotSize],
          //   state.plotStatus,
          //   state.showMyPlots
          // );
        }
        zoomLevelRef.current.zoomLevel = newZoom;
      }
    });
  };

  const setUpMap = useCallback(SetupMapHelper(), []);
  useEffect(() => {
    if (plotsDataRef.current != null) {
      filterPlots(
        plotslayerRef.current,
        account,
        plotsDataRef.current,
        [state.plotSize],
        state.plotStatus,
        state.showMyPlots
      );
    }
  }, [state.plotSize, state.plotStatus, state.showMyPlots]);

  const checkLockedPlots = async () => {
    try {
      getAndReleaseLockedCondo(account, eithAuthToken, values);
      const lockedPlots = await getPreviousLockedPlots(
        "plots",
        account,
        CHAIN.EITH
      );

      if (lockedPlots?.length > 0) {
        setState((state) => {
          return {
            ...state,
            showBuyModal: true,
            inventoryType: INVENTORY_TYPE.PLOT,
            plotId: lockedPlots[0]?.plot_id,
            selectedPlot: lockedPlots[0],
          };
        });
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (account && eithAuthToken) {
      checkLockedPlots();
    }
  }, [account, eithAuthToken]);

  useEffect(() => {
    if (plotslayerRef.current) {
      addPlotChangeListener();
      // setupZoomListener();//TEMP disable, manage  state TODO
    }
  }, [plotslayerRef.current]);

  useEffect(() => {
    setState((state) => ({ ...state, isLoadingData: true }));
    mapRef.current = setUpMap();
    mapSelector.current = addMapSelect(mapRef.current, handlePlotSelection);

    getPlotsLayer(values, (layer, plotsData) => {
      plotslayerRef.current = layer;
      if (plotsData?.length > 0) {
        mapRef.current.addLayer(plotslayerRef.current);
        plotsDataRef.current = plotsData;
      } else {
        plotsDataRef.current = null;
      }
      setState((state) => ({
        ...state,
        isLoadingData: false,
      }));
      // if (plotsData?.length > 0) {
      //   mapRef.current.addLayer(plotslayerRef.current);
      //   addPlotChangeListener();
      //   plotsDataRef.current = plotsData;
      // } else {
      //   plotsDataRef.current = null;
      // }

      // setState((state) => ({
      //   ...state,
      //   isLoadingData: false,
      // }));

      // ==
      // getPlotsMataData(plotslayerRef.current,plotsData, (plotsData) => {
      //   console.log("getPlotsMataData====>>", plotsData);
      //   if (plotsData?.length > 0) {
      //     mapRef.current.addLayer(plotslayerRef.current);
      //     addPlotChangeListener();
      //     plotsDataRef.current = plotsData;
      //   } else {
      //     plotsDataRef.current = null;
      //   }

      //   setState((state) => ({
      //     ...state,
      //     isLoadingData: false,
      //   }));
      // });
    });
    return () => {
      firestoreListnerRef.current?.();
    };
  }, []);

  const addPlotChangeListener = () => {
    firestoreListnerRef.current?.();
    firestoreListnerRef.current = addEithPlotChangeListner(
      plotMataDataChangeListnerHelper(plotsDataRef, plotslayerRef.current)
    );
  };

  return (
    <>
      <div>{state.isLoadingData && <CustomLoader />}</div>

      <div id="map" style={{ width: "100%", height: "100vh" }}></div>

      <Filters
        filtersState={{ state, setState }}
        chain={CHAIN.EITH}
        disabled={state.isLoadingData}
      />
      {state.showBuyModal && (
        <ModalBuyPlot
          showModal={state.showBuyModal}
          closeModal={handleCloseBuyModal}
          plotDetail={state.selectedPlot}
        />
      )}
      {state.showBuySuccesModal && (
        <ModalBuyPlotTxnSuccess
          showModal={state.showBuySuccesModal}
          closeModal={handleCloseSucessModal}
          itemDetail={state.selectedPlot}
        />
      )}

      {state.isShowPlotDetail && (
        <ModalInventoryDetail
          showDetail={state.isShowPlotDetail}
          inventory={state.selectedPlot}
          closeModal={() => {
            setState((state) => ({ ...state, isShowPlotDetail: false }));
          }}
        />
      )}
      {state.showCondoPurchase && (
        <ModalBuyCondo
          showModal={state.showCondoPurchase}
          closeModal={handleCloseBuyCondoModal}
        />
      )}
      <div id="newmarker" title="Empyrean Tower">
        <div></div>
      </div>
    </>
  );
};

export default EthMap;
